module.exports = "## Popover\n\nA `Popover` can be used as an alternative to a [Drop Down Menu](/#/components/dropdown-menu)\nthat can contain elements inside. In our examples we are using a [Menu](/#/components/menu),\nbut any suitable combination of components can be used.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Popover/README.md
 ** module id = 1030
 ** module chunks = 0
 **/